export default __webpack_public_path__ + "static/media/YAS0840.34I-37995_-25460_0.ef9ffaa3.jpg";